<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="单据状态">
                                <FGDictSelectCN dictNo="DW300101" v-model="queryParams.djzt" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="投稿单编号">
                                <a-input v-model="queryParams.djbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>

        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <!-- 工具栏 -->
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert">新增</a-button>
                        <a-button-group class="btnGroupCls">
                            <a-button :type="queryParams.selDJZT === 0 ? 'primary' : 'default'" @click="handleSelDjztChange(0)">
                                全部
                            </a-button>
                            <a-button :type="queryParams.selDJZT === 1 ? 'primary' : 'default'" @click="handleSelDjztChange(1)">
                                待提交
                            </a-button>
                            <a-button :type="queryParams.selDJZT === 2 ? 'primary' : 'default'" @click="handleSelDjztChange(2)">
                                已提交
                            </a-button>
                        </a-button-group>
                    </template>
                </vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(1)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="60" align="center" fixed="left"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" min-width="100" align="center"> </vxe-table-column>
                    <vxe-table-column field="djbh" title="投稿单编号" min-width="140" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="lxr" title="联系人" min-width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="lxfs" title="联系方式" min-width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="qq" title="QQ" min-width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="jj" title="简介" min-width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="gjc" title="关键词" min-width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="lrrq" title="创建日期" min-width="150" align="center"></vxe-table-column>
                    <vxe-table-column field="tjrq" title="提交日期" min-width="150" align="center"></vxe-table-column>
                    <vxe-table-column title="操作" min-width="160" align="center" fixed="right">
                        <template v-slot="scope">
                            <span class="btn_edit" v-if="getState(scope.row.djzt) === 1" @click="remove(scope.row)">删除</span>
                            <span class="btn_edit" v-if="getState(scope.row.djzt) === 1" @click="edit(scope.row)">编辑</span>
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top: 5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "TgsqBrowse",
    props: ["dataId", "submited", "componentName"],
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { djbh: "", selDJZT: 1 },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "djbh",
                order: "desc"
            },
            tableDataLoading: false,
            editProps: {
                showEdit: false,
                dataId: null
            }
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.componentName;
            },
            set(newVal) {
                this.$emit("update:componentName", newVal);
            }
        },

        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) !== 1) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        //选择不同状态
        handleSelDjztChange(selType) {
            this.queryParams.selDJZT = selType;
            this.loadData();
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            this.editIsVisible = "TgsqForm";
        },
        //删除
        remove(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zxdw/tggl/tggl/remove", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                this.loadData();
                            }
                        });
                }
            });
        },
        //查询列表数据
        loadData() {
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/tggl/tggl/list",
                    {
                        funid: "TG1002",
                        menuid: "B80538C2-A179-4ED7-9F85-43781DD0DFB0",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = { selDJZT: 0 };
        },
        //新增
        insert() {
            this.editDataId = null;
            this.editIsVisible = "TgsqEdit";
        },
        // 编辑
        edit(row) {
            this.editDataId = row.id;
            this.editIsVisible = "TgsqEdit";
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            }
            if (state === "提交") {
                return 0;
            }
        }
    }
};
</script>
